import {
  join,
  map,
  values,
  pick,
  propOr,
  match,
  compose,
  curry,
  call,
  prop,
  pathOr
} from 'ramda'
import { titleCase } from 'change-case'
import { createSelector } from 'reselect'
import { pathToJS as reversePathToJS } from 'react-redux-firebase'

const pathToJS = curry((path, firebase) =>
  call(reversePathToJS, firebase, path)
)

export const getFirebase = prop('firebase')
export const getRouterState = pathOr({}, ['router', 'location', 'state'])

export const getAuthError = createSelector(getFirebase, pathToJS('authError'))
export const getAuth = createSelector(getFirebase, pathToJS('auth'))
export const getIsInitializing = createSelector(
  getFirebase,
  pathToJS('isInitializing')
)

export const getIsAuthenticating = createSelector(
  [getIsInitializing, getAuth],
  (isInitializing, auth) => isInitializing === true || auth === undefined
)
export const getIsAuthenticated = createSelector(getAuth, Boolean)

export const getHumanReadableAuthErrorCode = createSelector(
  getAuthError,
  compose(
    join(' - '),
    map(titleCase),
    values,
    pick([1, 2]),
    match(/([\w-]*)\/([\w-]*)/),
    propOr('', 'code')
  )
)

export const getRouterCustomerId = createSelector(getRouterState, prop('id'))



// WEBPACK FOOTER //
// ./src/store/selectors/index.js